import React, {HTMLProps} from 'react';

// Component ----

type FieldLabelProps = HTMLProps<HTMLLabelElement>

function FieldLabel({children, ...props}: FieldLabelProps) {
    return (
        <label className="block text-sm font-medium leading-6 text-gray-700" {...props}>
            {children}
        </label>
    );
}

export default FieldLabel;